import { Grid } from "@mui/material";
import { Box } from "@mui/system";

export default function Contact() {
  return (
    <Box sx={{ flexGrow: 1, width: "50vw", margin: "auto",marginTop:'5%',marginBottom:'5%' }}>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 4, md: 12 }}
      >
        <Grid item xs={4} sm={4} md={8}>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2521.971007482403!2d3.18090551611321!3d50.7946458795243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c32fdb9d25d333%3A0x47ec0b01a1616a03!2sMenenstraat%2024%2C%208930%20Menen!5e0!3m2!1sen!2sbe!4v1647094319808!5m2!1sen!2sbe" style={{width:'100%', height:'100%'}} allowfullscreen="" loading="lazy"></iframe>
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <div>
            <p>Kris Bouvyn</p>
            <p>Boekhoudkantoor A-Census BV</p>
            <p>Menenstraat 24 Bus 0001</p>
            <p>8930 Lauwe </p>
            <p>Tel 056/42 64 69</p>
            <p>Fax 056/42 78 05</p>
            <p>E-mail : <a href="mailto:kris@acensus.be">kris@acensus.be</a></p>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}
